/**
 * Dahley Tonia — Ajax winkelwagenlade
 * Uitschuifbare winkelwagen met toevoegen-aan-winkelwagen, upsell en drempel voor gratis verzending.
 * Namen en afbeeldingen van winkelwagenartikelen linken naar hun productpagina's.
 * Toont een melding wanneer een artikel is uitverkocht of niet beschikbaar is.
 *
 * Drempel voor gratis verzending wordt uitgelezen uit data-threshold op het verzendingsbalk-element.
 * Stel de waarde in via de theme-instelling "free_shipping_threshold" in de Shopify customizer.
 * Bij een drempel van 0 geldt altijd gratis verzending.
 */
(function() {
  'use strict';

  var overlay = document.getElementById('dt-cart-overlay');
  var drawer = document.getElementById('dt-cart-drawer');
  var itemsContainer = document.getElementById('dt-cart-items');
  var countEls = document.querySelectorAll('[data-cart-count]');
  var subtotalEl = document.getElementById('dt-cart-subtotal');
  var shippingTextEl = document.getElementById('dt-cart-shipping-text');
  var shippingBarEl = document.getElementById('dt-cart-shipping-bar');
  var footerEl = document.getElementById('dt-cart-footer');
  var upsellEl = document.getElementById('dt-cart-upsell');
  var noticeEl = document.getElementById('dt-cart-notice');
  var noticeTimer = null;
  var upsellVisible = true;

  // Lees de drempel uit het data-attribuut dat door Liquid is ingevuld via de theme-instelling.
  // Valt terug op 7500 (= €75,00) als het attribuut ontbreekt of ongeldig is.
  // Bij 0 geldt altijd gratis verzending.
  var FREE_SHIPPING_THRESHOLD = shippingBarEl
    ? parseInt(shippingBarEl.getAttribute('data-threshold'), 10)
    : 7500;

  if (isNaN(FREE_SHIPPING_THRESHOLD)) {
    FREE_SHIPPING_THRESHOLD = 7500;
  }

  function requestJSON(url, options) {
    return fetch(url, options).then(function(response) {
      return response.json().catch(function() {
        return {};
      }).then(function(data) {
        if (!response.ok) {
          data.status = data.status || response.status;
          throw data;
        }
        return data;
      });
    });
  }

  function vertaalWinkelTekst(tekst) {
    if (!tekst) return '';

    return String(tekst)
      .replace(/\bABV\b/gi, 'alcohol')
      .replace(/\bDefault Title\b/gi, 'Standaard')
      .replace(/\bOne Size\b/gi, 'Eén maat')
      .replace(/\bExtra Large\b/gi, 'Extra groot')
      .replace(/\bSmall\b/gi, 'Klein')
      .replace(/\bMedium\b/gi, 'Medium')
      .replace(/\bLarge\b/gi, 'Groot')
      .replace(/\bSize\b/gi, 'Formaat')
      .replace(/\bOption\b/gi, 'Optie');
  }

  function showNotice(message) {
    if (!noticeEl) return;
    noticeEl.textContent = message;
    noticeEl.hidden = false;

    if (noticeTimer) {
      window.clearTimeout(noticeTimer);
    }

    noticeTimer = window.setTimeout(function() {
      clearNotice();
    }, 5000);
  }

  function clearNotice() {
    if (!noticeEl) return;
    noticeEl.hidden = true;
    noticeEl.textContent = '';
  }

  function getCartErrorMessage(error) {
    var message = '';

    if (error && error.description) message = error.description;
    else if (error && error.message) message = error.message;

    if (!message) {
      return 'Sorry, dit product is uitverkocht.';
    }

    message = String(message)
      .replace(/Sorry, this product is out of stock\.?/gi, 'Sorry, dit product is uitverkocht.')
      .replace(/This product is unavailable\.?/gi, 'Dit product is niet beschikbaar.')
      .replace(/The product is already sold out\.?/gi, 'Dit product is al uitverkocht.')
      .replace(/You can't add more of this item to the cart\.?/gi, 'Je kunt niet meer van dit artikel aan de winkelwagen toevoegen.')
      .replace(/Cart Error\.?/gi, 'Fout in winkelwagen.');

    return vertaalWinkelTekst(message);
  }

  function openCart() {
    if (drawer) drawer.classList.add('dt-cart-drawer--open');
    if (overlay) overlay.classList.add('dt-cart-overlay--open');
    document.body.style.overflow = 'hidden';
    refreshCart();
  }

  function closeCart() {
    if (drawer) drawer.classList.remove('dt-cart-drawer--open');
    if (overlay) overlay.classList.remove('dt-cart-overlay--open');
    document.body.style.overflow = '';
    clearNotice();
  }

  var closeBtn = document.getElementById('dt-cart-close');
  if (closeBtn) closeBtn.addEventListener('click', closeCart);
  if (overlay) overlay.addEventListener('click', closeCart);

  document.querySelectorAll('[data-open-cart]').forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      openCart();
    });
  });

  function refreshCart() {
    requestJSON('/cart.js', { credentials: 'same-origin' })
      .then(renderCart)
      .catch(function(err) {
        console.error('Fout bij ophalen van winkelwagen:', err);
      });
  }

  function renderCart(cart) {
    countEls.forEach(function(el) {
      el.textContent = cart.item_count;
    });

    // Voorkom delen door nul als drempel op 0 staat — dan altijd gratis verzending tonen
    var progress, remaining;
    if (FREE_SHIPPING_THRESHOLD === 0) {
      progress = 100;
      remaining = 0;
    } else {
      progress = Math.min(100, (cart.total_price / FREE_SHIPPING_THRESHOLD) * 100);
      remaining = Math.max(0, FREE_SHIPPING_THRESHOLD - cart.total_price);
    }

    if (shippingBarEl) shippingBarEl.style.width = progress + '%';

    if (shippingTextEl) {
      shippingTextEl.innerHTML = remaining > 0
        ? 'Voeg nog <span>' + formatMoney(remaining) + '</span> toe voor gratis verzending'
        : '<span>Je komt in aanmerking voor gratis verzending!</span>';
    }

    if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);
    if (footerEl) footerEl.style.display = cart.item_count > 0 ? '' : 'none';

    if (!itemsContainer) return;

    if (cart.item_count === 0) {
      itemsContainer.innerHTML = '<div class="dt-cart-drawer__empty"><p>Je winkelwagen is leeg</p></div>';
      if (upsellEl) upsellEl.style.display = 'none';
      return;
    }

    var html = '';

    cart.items.forEach(function(item) {
      var productUrl = item.url ? item.url.split('?')[0] : '#';
      var productTitle = vertaalWinkelTekst(item.product_title);
      var variantTitle = item.variant_title ? vertaalWinkelTekst(item.variant_title) : '';

      html += '<div class="dt-cart-drawer__item" data-line-key="' + item.key + '">';
      html += '  <div class="dt-cart-drawer__item-img"><a href="' + productUrl + '"><img src="' + getSizedImage(item.image, '200x') + '" alt="' + escapeHtml(productTitle || item.title) + '"></a></div>';
      html += '  <div class="dt-cart-drawer__item-info">';
      html += '    <div style="display:flex;justify-content:space-between;align-items:flex-start;">';
      html += '      <div><p class="dt-cart-drawer__item-name"><a href="' + productUrl + '">' + escapeHtml(productTitle) + '</a></p>';

      if (variantTitle) {
        html += '<p class="dt-cart-drawer__item-variant">' + escapeHtml(variantTitle) + '</p>';
      }

      html += '      </div>';
      html += '      <button class="dt-cart-drawer__item-remove" data-remove-key="' + item.key + '" aria-label="Verwijderen"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M18 6L6 18M6 6l12 12" stroke-linecap="round"/></svg></button>';
      html += '    </div>';
      html += '    <div class="dt-cart-drawer__item-bottom">';
      html += '      <div class="dt-cart-drawer__item-qty">';
      html += '        <button data-qty-change="' + item.key + '" data-qty="' + (item.quantity - 1) + '">−</button>';
      html += '        <span>' + item.quantity + '</span>';
      html += '        <button data-qty-change="' + item.key + '" data-qty="' + (item.quantity + 1) + '">+</button>';
      html += '      </div>';
      html += '      <p class="dt-cart-drawer__item-price">' + formatMoney(item.final_line_price) + '</p>';
      html += '    </div>';
      html += '  </div>';
      html += '</div>';
    });

    itemsContainer.innerHTML = html;

    itemsContainer.querySelectorAll('[data-qty-change]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        updateQuantity(
          this.getAttribute('data-qty-change'),
          parseInt(this.getAttribute('data-qty'), 10)
        );
      });
    });

    itemsContainer.querySelectorAll('[data-remove-key]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        updateQuantity(this.getAttribute('data-remove-key'), 0);
      });
    });

    if (upsellEl) {
      upsellEl.style.display = cart.item_count > 0 && upsellVisible ? '' : 'none';
    }
  }

  document.addEventListener('click', function(e) {
    var hideBtn = e.target.closest('[data-hide-upsell]');
    if (hideBtn) {
      upsellVisible = false;
      if (upsellEl) upsellEl.style.display = 'none';
    }
  });

  document.addEventListener('click', function(e) {
    var btn = e.target.closest('[data-upsell-add]');
    if (!btn) return;

    e.preventDefault();

    var variantId = btn.getAttribute('data-upsell-add');
    if (variantId && window.DahleyToniaCart) {
      window.DahleyToniaCart.add(parseInt(variantId, 10), 1);
    }
  });

  window.DahleyToniaCart = {
    add: function(variantId, quantity) {
      quantity = quantity || 1;

      return requestJSON('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ id: variantId, quantity: quantity })
      })
        .then(function(item) {
          clearNotice();
          openCart();
          return item;
        })
        .catch(function(err) {
          openCart();
          showNotice(getCartErrorMessage(err));
          console.error('Fout bij toevoegen aan winkelwagen:', err);
          return null;
        });
    },
    open: openCart,
    close: closeCart,
    refresh: refreshCart
  };

  function updateQuantity(key, quantity) {
    requestJSON('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function(cart) {
        clearNotice();
        renderCart(cart);
      })
      .catch(function(err) {
        showNotice(getCartErrorMessage(err));
        console.error('Fout bij bijwerken van aantal:', err);
        refreshCart();
      });
  }

  function formatMoney(cents) {
    var amount = (Number(cents) || 0) / 100;

    if (window.Intl && Intl.NumberFormat) {
      return new Intl.NumberFormat('nl-NL', {
        style: 'currency',
        currency: 'EUR'
      }).format(amount);
    }

    return '€ ' + amount.toFixed(2).replace('.', ',');
  }

  function getSizedImage(src, size) {
    if (!src) return '';
    return src.replace(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif|webp)(\?v=\d+)?$/i, '_' + size + '.$1$2');
  }

  function escapeHtml(str) {
    if (!str) return '';
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  document.addEventListener('click', function(e) {
    var btn = e.target.closest('[data-add-to-cart]');
    if (!btn) return;

    e.preventDefault();

    var variantId = btn.getAttribute('data-add-to-cart');
    var qtyInput = btn.closest('form') ? btn.closest('form').querySelector('[name="quantity"]') : null;
    var qty = qtyInput ? parseInt(qtyInput.value, 10) : 1;

    window.DahleyToniaCart.add(parseInt(variantId, 10), qty);
  });

  refreshCart();
})();